// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_27-2";
export var blackBorderOnHover = "_27-7";
export var cell = "_27-6";
export var cellContainer = "_27-3";
export var checked = "_27-8";
export var disabled = "_27-5";
export var featuredIconCellContainer = "_27-9";
export var featuredIconTextContainer = "_27-b";
export var featuredIconWrapper = "_27-a";
export var noBorder = "_27-c";
export var orangeSelectedRow = "_4z-3";
export var overflowableText = "_27-0";
export var overflowableTextContainer = "_27-1";
export var row = "_1q-0";
export var rowCheckboxCell = "_27-4";
export var selectableTable = "_4z-2";